<template>
  <table class="table is-fullwidth">
    <tr>
      <td>Image</td>
      <td>Name</td>
      <td>Цахим шуудан</td>
    </tr>
    <tr v-for="user in device.users" :key="user.id">
      <td>
        <div class="image is-32x32">
          <img :src="user.profile_picture.sm" class="is-rounded" />
        </div>
      </td>
      <td>
        <router-link :to="'/users/' + user.id" :key="user.id" style="margin-right: 5px;">
          <b-tooltip :label="user.id">{{user.name}}</b-tooltip>
        </router-link>
      </td>
      <td>{{user.email}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: ["device"],

  data() {
    return {};
  },

  methods: {}
};
</script>
